function DashboardActiveHeaderSession( {value} ) {
    const sessionName = {
        0: "Practice",
        1: "Qualify",
        2: "Race",
        3: "HotLap",
        4: "Time Attack",
        5: "Drift",
        6: "Drag",
        7: "Hot Stint",
        8: "Hot Stint SuperPole"
    }[value["session-type"]] || "Uknown";

    const formatTime = (ms) => {
        if (ms === "∞") return ms;

        const h = Math.floor(ms / 3600000);
        const m = Math.floor((ms % 3600000) / 60000);
        const s = Math.floor((ms % 60000) / 1000);

        const mm = m < 10 ? `0${m}` : m;
        const ss = s < 10 ? `0${s}` : s;

        if (h > 0) {
            return `${h}:${mm}:${ss}`;
        } else {
            return `${m}:${ss}`;
        }
    };

    return (
        <div className="flex h-10 items-center gap-4 border-x border-[#233648] px-4 mr-2">
            <div className="flex flex-col">
                <span className="text-[10px] uppercase text-[#92adc9] font-bold">Session</span>
                <span className="text-sm font-bold">{sessionName}</span>
            </div>

            <div className="flex flex-col">
                <span className="text-[10px] uppercase text-[#92adc9] font-bold">Remaining</span>
                <span className="text-sm font-bold text-acc-yellow">{formatTime(value["time-left"])}</span>
            </div>
        </div>
    );
}

export default DashboardActiveHeaderSession;